import { createContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useLazyGetPendingContractByIdQuery } from "../../app/services/pendingContractAPI";

const PendingContractContext = createContext();

const PendingContractProvider = ({ children }) => {
    const [pendingContractData, setPendingContractData] = useState(null);
    const [isPendingContractUpdated, setIsPendingContractUpdated] = useState(false);
    const url = window.location.search;
    const pendingContractId = new URLSearchParams(url).get("pendingContract");

    const [getPendingContract, {
        isSuccess: isPendingContractFetched,
        data: pendingContractDatas,
    },] = useLazyGetPendingContractByIdQuery();


    useEffect(() => {
        if (pendingContractId) {
            const request = {
                plPendingContractKey: pendingContractId,
                pbIncludeInactive: false,
                psPendingContractName: ""
            }
            getPendingContract(request);
        }
    }, [pendingContractId, isPendingContractUpdated, getPendingContract]);


    useEffect(() => {
        if (isPendingContractFetched && pendingContractDatas) {
            setPendingContractData(pendingContractDatas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingContractFetched, pendingContractDatas]);


    const value = useMemo(() => ({
        pendingContractId,
        pendingContractData,
        setPendingContractData,
        isPendingContractUpdated,
        setIsPendingContractUpdated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [pendingContractData, isPendingContractUpdated, pendingContractId]);

    return (
        <PendingContractContext.Provider value={value}>
            {children}
        </PendingContractContext.Provider>
    );
}
PendingContractProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
export { PendingContractProvider, PendingContractContext }